/**
 * Where the chat thinks it is running. Normally that is the browser address, but the Chatbot Builder
 * MCP card mounts this app inside Claude, where window.location is Claude's sandbox. The card sets
 * window.__CBB_MOUNT__ to the chat address it would have opened, so the environment, the route and
 * preview detection come out the same as on the real page.
 */
declare global {
  interface Window {
    __CBB_MOUNT__?: { url?: string };
  }
}

type PageLocation = Pick<Location, "hostname" | "pathname" | "href" | "search">;

function mountedUrl(): URL | null {
  try {
    const url = window.__CBB_MOUNT__?.url;
    return url ? new URL(url) : null;
  } catch {
    return null;
  }
}

export function isMountedInCard() {
  return mountedUrl() !== null;
}

export function pageLocation(): PageLocation {
  return mountedUrl() || window.location;
}
